import { v4 as uuidv4 } from "uuid";

const songData = [
    {
        title: "Alone",
        artist: "Alan walker",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1676137335599alone.jpg?alt=media&token=4f67a7d4-fd0e-4d4b-a39d-189c17cf4e57",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1676137335599alone.jpg?alt=media&token=4f67a7d4-fd0e-4d4b-a39d-189c17cf4e57",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1676137335599Alan_Walker_Ava_Max_-_Alone_Pt_2_CeeNaija.com_.mp3?alt=media&token=792dc664-fccf-43b6-a830-1b215c83b349",
        palette: "green",
        id: uuidv4(),
    },
    {
        title: "Khalouni",
        artist: "singer Indila",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1676142043364download.jpg?alt=media&token=8769379d-6e9b-4370-a3bd-cd89b223c7bf",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1676142043364download.jpg?alt=media&token=8769379d-6e9b-4370-a3bd-cd89b223c7bf",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1676137335598Arabic-Remix---Khalouni-N3ich-(Yusuf-Eksioglu-Remix)(MrSong.In).mp3?alt=media&token=7aa002e6-298a-4bf2-95f8-7a6e01063323",
        palette: "yellow",
        id: uuidv4(),
    },
    {
        title: "La Casa De Papel",
        artist: "Cecilia Krull",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675107271901download%20(1).jpeg?alt=media&token=3795c023-fafd-4725-90f4-61c090f64fbb",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675107271901download%20(1).jpeg?alt=media&token=3795c023-fafd-4725-90f4-61c090f64fbb",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675105849131My-life-is-going-on-.mp3?alt=media&token=9892ed08-fc60-46c1-8096-e2463d2dbdf4",
        palette: "coral",
        id: uuidv4(),
    },
    {
        title: "Ainsi bas la vida",
        artist: "singer Indila",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675107959564download%20(2).jpeg?alt=media&token=01a11c6d-ef4f-4b5f-8368-6620fe197576",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675107959564download%20(2).jpeg?alt=media&token=01a11c6d-ef4f-4b5f-8368-6620fe197576",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675107959564Ainsi-Bas-La-Vida_320(PaglaSongs).mp3?alt=media&token=0d512390-71e6-4a58-be9c-1f9815d14abd",
        palette: "yellow",
        id: uuidv4(),
    },
    {
        title: "despacito-artwork",
        artist: "Luis Fonsi",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675325122899Luis-Fonsi-Ft-Daddy-Yankee-And-Justin-Bieber-Despacito-Remix-Art.jpg?alt=media&token=88039e7d-549a-41cc-8dc4-10231fee59bb",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675325122899Luis-Fonsi-Ft-Daddy-Yankee-And-Justin-Bieber-Despacito-Remix-Art.jpg?alt=media&token=88039e7d-549a-41cc-8dc4-10231fee59bb",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675325136453Luis-Fonsi-Ft-Daddy-Yankee-Despacito-(TrendyBeatz.com).mp3?alt=media&token=a19d5470-2ac3-4f0b-b147-3ad003edeb2f",
        palette: "red",
        id: uuidv4(),
    },
    {
        title: "Arcade",
        artist: "Duncan Laurence",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675325479075download%20(3).jpeg?alt=media&token=f5e98e91-e3da-45b7-948b-d14378672558",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675325479075download%20(3).jpeg?alt=media&token=f5e98e91-e3da-45b7-948b-d14378672558",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675325494448Arcade_320(PagalWorld).mp3?alt=media&token=f3b94e29-8c8a-4a14-8544-4001136d10a0",
        palette: "blue",
        id: uuidv4(),
    },

    {
        title: "Joker",
        artist: "Anna Rossinelli",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675328514735download%20(9).jpeg?alt=media&token=8d7c635f-7aed-471b-9351-935e628cf246",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675328514735download%20(9).jpeg?alt=media&token=8d7c635f-7aed-471b-9351-935e628cf246",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675326085607Joker%20BGM%20Song%20Bass%20Boosted%202020(DjJpSwami.Com).mp3?alt=media&token=9bfcd783-2128-47ca-80be-a33554828c63",
        palette: "brown",
        id: uuidv4(),
    },
    {
        title: "Everything's Electric",
        artist: "Liam Gallagher",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675326898883download%20(5).jpeg?alt=media&token=d2913ac5-e362-49cc-996d-3195ff62c087",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675326898883download%20(5).jpeg?alt=media&token=d2913ac5-e362-49cc-996d-3195ff62c087",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675326898883Liam%20Gallagher%20-%20Everything's%20Electric%20Lyrics.mp3?alt=media&token=b36673a6-74c4-4410-8338-88d947df4971",
        palette: "darkgrey",
        id: uuidv4(),
    },
    {
        title: "Lofi Fruits Music",
        artist: "Gangsta's Paradise",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675328399988download%20(8).jpeg?alt=media&token=bfae5ca0-8b0e-438d-bcae-4fc6a519baae",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675328399988download%20(8).jpeg?alt=media&token=bfae5ca0-8b0e-438d-bcae-4fc6a519baae",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675327279614Gangsta's%20Paradise%20-%20Lofi%20Fruits%20Music%20%5BTikTok%20Remix%5D.mp3?alt=media&token=7cd2c331-c23d-4f71-926b-9b40a39056fe",
        palette: "grey",
        id: uuidv4(),
    },
    {
        title: "Unstoppable",
        artist: "Sia",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675327540902download%20(7).jpeg?alt=media&token=9d07fcea-4cfc-42c6-b506-31b6bf5c4c53",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675327540902download%20(7).jpeg?alt=media&token=9d07fcea-4cfc-42c6-b506-31b6bf5c4c53",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675327540902Unstoppable_320(PaglaSongs).mp3?alt=media&token=269d326b-1edb-48f1-9092-24e434e8ea2b",
        palette: "yellow",
        id: uuidv4(),
    },
    {
        title: "Dusk Till Dawn",
        artist: "Sam Smith, Ali Gatie, Ruth B",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675331531139images%20(2).jpeg?alt=media&token=ecea0644-0fa8-42c1-967e-a71d8b1c5599",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675331531139images%20(2).jpeg?alt=media&token=ecea0644-0fa8-42c1-967e-a71d8b1c5599",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675329067531Dusk%20Till%20Dawn(Mr-Jatt1.com).mp3?alt=media&token=d34323b9-d117-47d6-b816-f65b8cf9c5f8",
        palette: "grey",
        id: uuidv4(),
    },

    {
        title: "Ghost",
        artist: "Justin Bieber",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675329783711images.jpeg?alt=media&token=6cc8c261-b20c-4bf9-9b53-c47bd1dcc3b4",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675329783711images.jpeg?alt=media&token=6cc8c261-b20c-4bf9-9b53-c47bd1dcc3b4",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675330786702Ghost%20-%20Justin%20Bieber%20%5BLyrics%5D%20%20Charlie%20Puth%2C%20Shawn%20Mendes.mp3?alt=media&token=1bf9abcf-e1b5-4144-b9d3-502313138963",
        palette: "darkgrey",
        id: uuidv4(),
    },
    {
        title: "Sigma rule",
        artist: "Zedline Pagalworld",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675331210135images%20(1).jpeg?alt=media&token=c4c374f0-72a7-49b6-9e5e-0466633b97cd",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675331210135images%20(1).jpeg?alt=media&token=c4c374f0-72a7-49b6-9e5e-0466633b97cd",
        audio: "https://mp3.chillhop.com/serve.php/?mp3=8002",
        palette: "teal",
        id: uuidv4(),
    },
    {
        title: "Fairytale",
        artist: " Alexander Rybak",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675340016272size_l.jpg?alt=media&token=81b7206c-2ba2-436f-a23a-99fd7760d0b2",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675340016272size_l.jpg?alt=media&token=81b7206c-2ba2-436f-a23a-99fd7760d0b2",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675340016272Fairy%20Tale(Mr-Jatt1.com).mp3?alt=media&token=477d1222-7821-4548-91b4-0f5991c23724",
        palette: "cyan",
        id: uuidv4(),
    },
    {
        title: "Middle of the Night",
        artist: "Elley Duhé",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675340341062download%20(11).jpeg?alt=media&token=16f5cd47-c6d4-470a-84c5-1566e0a50537",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675340341062download%20(11).jpeg?alt=media&token=16f5cd47-c6d4-470a-84c5-1566e0a50537",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675340341062Elley_Duhe_-_Middle_Of_The_Night_(Jesusful.com).mp3?alt=media&token=bfdd6c7c-e49c-4837-a6a5-bcc05d9cc3ef",
        palette: "purple",
        id: uuidv4(),
    },
    {
        title: "Nightcore",
        artist: "Thomas, Steffen",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675340907296download%20(12).jpeg?alt=media&token=88c2e826-925c-4d2c-9e58-cf43459c9ce8",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675340907296download%20(12).jpeg?alt=media&token=88c2e826-925c-4d2c-9e58-cf43459c9ce8",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675340907297black-box-nightmare-125251.mp3?alt=media&token=fd65d0a8-9f92-4fae-82d3-eeaeb63be529",
        palette: "pink",
        id: uuidv4(),
    },
    {
        title: "Another Nation",
        artist: "Stella Chronopoulou",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675341672451download%20(14).jpeg?alt=media&token=e03eb610-1c90-4661-b5dc-918ee069d369",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675341672451download%20(14).jpeg?alt=media&token=e03eb610-1c90-4661-b5dc-918ee069d369",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675341672451Another%20Nation.mp3?alt=media&token=e7c29da9-620b-4fe4-8724-29aae1f514fb",
        palette: "orange",
        id: uuidv4(),
    },
    {
        title: "Unity",
        artist: "Alen walker",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675341208621download%20(13).jpeg?alt=media&token=f88cfe5f-8a87-4af6-b7d8-f12c8c148fb4",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675341208621download%20(13).jpeg?alt=media&token=f88cfe5f-8a87-4af6-b7d8-f12c8c148fb4",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675341208622Unity---Alan-x-Walkers(PagalWorldl).mp3?alt=media&token=829042a9-ab27-4ea8-b902-eead8282b41b",
        palette: "cyan",
        id: uuidv4(),
    },
    {
        title: "League of Legends",
        artist: "Bo Chen",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677432164626images%20(5).jpeg?alt=media&token=56214996-0b19-4efd-a7fc-7bf728fee227",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677432164626images%20(5).jpeg?alt=media&token=56214996-0b19-4efd-a7fc-7bf728fee227",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1675342328625League%20of%20Legends%20-%20War%20Song%20Remix%20%20No%20Copyright%20Sounds.mp3?alt=media&token=c4a81c85-8325-4adc-8e6d-05ff77d0a74c",
        palette: "orange",
        id: uuidv4(),
    },
    {
        title: "Izmir",
        artist: "Boss",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677431305698download%20(15).jpeg?alt=media&token=86160e6b-df25-4659-8aae-bff06b321749",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677431305698download%20(15).jpeg?alt=media&token=86160e6b-df25-4659-8aae-bff06b321749",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677431223430Izmir-Marsi(PaglaSongs).mp3?alt=media&token=7cb850e2-29c1-4d40-824d-9c5ce17b98f7",
        palette: "brown",
        id: uuidv4(),
    },
    {
        title: "Avengers",
        artist: "Boss",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677432098473images%20(4).jpeg?alt=media&token=5c40126e-e52b-47bf-8495-d2260cfaff76",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677432098473images%20(4).jpeg?alt=media&token=5c40126e-e52b-47bf-8495-d2260cfaff76",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677431716092avengers-theme-song-download.mp3?alt=media&token=2dadd9ea-733a-4598-abb5-b4b2eb3d7808",
        palette: "red",
        id: uuidv4(),
    },
    {
        title: "Broken Angel",
        artist: "Aarash",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677432848781images%20(6).jpeg?alt=media&token=db4e832b-304b-4477-a238-e36efba1ccf2",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677432848781images%20(6).jpeg?alt=media&token=db4e832b-304b-4477-a238-e36efba1ccf2",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677432635604ARASH%20feat%20HELENA%20-%20Broken%20Angel%20(English%20Hit%20Remix)(DJSathi).mp3?alt=media&token=aed53315-3326-44d4-8c3c-235ede5c2133",
        palette: "brown",
        id: uuidv4(),
    },
    {
        title: "Hymn of weekend",
        artist: "Boss",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677433142596download%20(17).jpeg?alt=media&token=4e3c6e92-15f4-46ae-83c2-5b5ea2bcabad",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677433142596download%20(17).jpeg?alt=media&token=4e3c6e92-15f4-46ae-83c2-5b5ea2bcabad",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677433102709Hymn-For-The-Weekend(PagalWorldl).mp3?alt=media&token=47bdc540-ade2-449d-9d40-20875e81823d",
        palette: "pink",
        id: uuidv4(),
    },
    {
        title: "Dark side",
        artist: "Boss",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677433528181download%20(18).jpeg?alt=media&token=b3ee399f-0336-4832-99b0-5c7bba432d4c",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677433528181download%20(18).jpeg?alt=media&token=b3ee399f-0336-4832-99b0-5c7bba432d4c",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677433459034Darkside(PaglaSongs).mp3?alt=media&token=18d5ebbe-721c-4e4e-848d-f277637e1454",
        palette: "blue",
        id: uuidv4(),
    },
    {
        title: "Wrinko",
        artist: "Boss",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677433908275download%20(19).jpeg?alt=media&token=41216ff6-6b16-4e7f-a635-923f43202f83",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677433908275download%20(19).jpeg?alt=media&token=41216ff6-6b16-4e7f-a635-923f43202f83",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677433765625Warriyo%20-%20Mortals%20(feat.%20Laura%20Brehm)(AllDjsMashup.Com).mp3?alt=media&token=d0633ab3-2544-4c01-9851-3a2a34f7061c",
        palette: "red",
        id: uuidv4(),
    },
    {
        title: "Here we go",
        artist: "Boss",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677434249197download%20(20).jpeg?alt=media&token=214de4cd-4cc0-478a-a2a2-46dbe5aeff9c",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677434249197download%20(20).jpeg?alt=media&token=214de4cd-4cc0-478a-a2a2-46dbe5aeff9c",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677434205833On-and-On(PaglaSongs).mp3?alt=media&token=62c6a1ff-7edf-4555-9532-54169f91e60c",
        palette: "orange",
        id: uuidv4(),
    },
    {
        title: "Wahran",
        artist: "Boss",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677434734533download%20(21).jpeg?alt=media&token=d893c05c-dae3-4bfe-871a-48b5a666c65a",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677434734533download%20(21).jpeg?alt=media&token=d893c05c-dae3-4bfe-871a-48b5a666c65a",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677434518728Wahran(PagalWorldl).mp3?alt=media&token=4c6e6696-8e02-446c-935a-0619efc3adef",
        palette: "orange",
        id: uuidv4(),
    },
    {
        title: "Welcome to my dark-side",
        artist: "Boss",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677435153333download%20(23).jpeg?alt=media&token=25fafcb8-7e29-4036-8c4b-d32c98e94767",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677435153333download%20(23).jpeg?alt=media&token=25fafcb8-7e29-4036-8c4b-d32c98e94767",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677435090626Darkside%20-%20Neoni-(DJMaza).mp3?alt=media&token=fcaeb080-c3ea-45ca-8b73-b238b5e16e36",
        palette: "black",
        id: uuidv4(),
    },
    {
        title: "Mockingbird",
        artist: "Eminem",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677945914170download%20(24).jpeg?alt=media&token=e7f96bb0-937e-4ec9-b046-a64526d74c0b",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677945914170download%20(24).jpeg?alt=media&token=e7f96bb0-937e-4ec9-b046-a64526d74c0b",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1677945914170Mockingbird%20-%20Eminem-(DJMaza).mp3?alt=media&token=f51ce9ed-b3e9-42b4-bf10-03c81e771613",
        palette: "black",
        id: uuidv4(),
    },
    {
        title: "Tubular Bells",
        artist: "Mike Oldfield",
        coverUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1678127426844download%20(25).jpeg?alt=media&token=c064e3ca-1856-4f92-a302-90ccd1c46607",
        thumbUrl:
            "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1678127426844download%20(25).jpeg?alt=media&token=c064e3ca-1856-4f92-a302-90ccd1c46607",
        audio: "https://firebasestorage.googleapis.com/v0/b/chat-web-app-46b89.appspot.com/o/chat%2F-NN33z-SkMdUFxVLBs8a%2F1678127174004X2Download%20(mp3cut.net)%20(1).mp3?alt=media&token=14d4d015-2ad1-4602-ab0e-a487040ac8d9",
        palette: "black",
        id: uuidv4(),
    },
];

export default songData;
